import React from 'react';
// import LoggerHelper from '../../../helpers/loggerHelper';
import { LoggerHelper } from 'ff-shared-components-core';
import { GenericErrorScreen } from '@shared/screens';

interface UnexpectedErrorInjectedProps {
	error: string; // injected by ErrorBoundary component
}

export class UnexpectedError extends React.Component<UnexpectedErrorInjectedProps> {
	componentDidMount(): void {
		const { error } = this.props;

		LoggerHelper.error('ERROR SCREEN UnexpectedError > ', error);
	}

	render(): React.ReactNode {
		// return null;
		return <GenericErrorScreen />;
	}
}
